import { config } from '../config';

export default {
	get
};

export const resourceService = {
	get
};

async function get(resource) {
	const date = new Date();

	const url = new URL(`${config.baseUrl}/${resource}?nocache${date.getTime()}`);

	const parameters = {
		method: 'GET'
	};

	try {
		const response = await fetch(url, parameters);
		const data = await handleResponse(response);

		return data;
	} catch (error) {
		return {
			isSuccess: false,
			data: error
		};
	}
}

async function handleResponse(response) {
	const text = await response.text();

	if (response.status === 200) {
		const data = JSON.parse(text);

		return {
			isSuccess: true,
			data: data
		};
	}

	return {
		isSuccess: false,
		data: text
	};
}
